'use client';

import { useState } from 'react';
import dynamic from 'next/dynamic';
import PrelineLoader from '@/components/config/PrelineLoader';
import Footer from '@/components/front/layout/Footer';
import FrontOfficeAdminBar from '@/components/front/layout/FrontOfficeAdminBar';
import FrontImageFallbackGuard from '@/components/front/layout/FrontImageFallbackGuard';
import ContentModalSearch from '@/components/front/ui/ContentModalSearch';

// Dynamically import Navbar component
const Navbar = dynamic(() => import('@/components/front/layout/Navbar'), { ssr: false });

const RootLayout = ({ children }) => {
    const [showFrontOfficeAdminBar, setShowFrontOfficeAdminBar] = useState(true);

    return (
        <div className="relative content-site">
            <FrontImageFallbackGuard />
            <FrontOfficeAdminBar
                isVisible={showFrontOfficeAdminBar}
                onToggleVisibility={() => setShowFrontOfficeAdminBar((currentValue) => !currentValue)}
            />
            <Navbar />
            {children}
            <hr />
            <Footer />
            <ContentModalSearch />
            <PrelineLoader />
        </div>
    );
};

export default RootLayout;
